import { Row } from '@fs/zion-ui'
import React from 'react'
import { usePageView } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../../app/PageTitleContext'
import DemotePromoteUserButton from './buttons/DemotePromoteUserButton'
import DeleteGroupUserButton from './buttons/DeleteGroupUserButton'
import UserGroupsList from './UserGroupsList'
import useUserGroups from './useUserGroups'

export default function UserGroups() {
  usePageView({ page_detail: 'DMConsole:UserGroups' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.user.groups'))
  const [userGroupsState, helpers] = useUserGroups()
  const atLeastOneGroupSelected = userGroupsState.selectedGroups.length > 0

  return (
    <>
      {userGroupsState.memberSummaries && (
        <>
          {userGroupsState.memberSummaries.length > 0 ? (
            <>
              <Row>
                {atLeastOneGroupSelected && (
                  <DemotePromoteUserButton
                    memberSummaries={userGroupsState.memberSummaries}
                    refreshUserGroupsDataAndControls={helpers.refreshUserGroupsDataAndControls}
                  />
                )}
                {atLeastOneGroupSelected && (
                  <DeleteGroupUserButton
                    memberSummaries={userGroupsState.memberSummaries}
                    refreshUserGroupsDataAndControls={helpers.refreshUserGroupsDataAndControls}
                  />
                )}
              </Row>
              <UserGroupsList
                setCheckedGroups={helpers.setCheckedGroups}
                memberSummaries={userGroupsState.memberSummaries}
                refreshUserGroupsDataAndControls={helpers.refreshUserGroupsDataAndControls}
              />
            </>
          ) : (
            t('user.groups.notFound', 'This user does not belong to any group.')
          )}
        </>
      )}
    </>
  )
}
